import React, { useEffect, useState } from 'react'
import { Permiso } from '../../../../../types/Permiso';
import { usePermiso } from '../../../../../hooks/usePermiso';
import { useRol } from '../../../../../hooks/useRol';
import { Rol } from '../../../../../types/Rol';
import { useTipoUsuario } from '../../../../../hooks/useTipoUsuario';
import { TipoUsuario } from '../../../../../types/TipoUsuario';

export const BuscarTipoUsuario = () => {
    const { tipoUsuarioInitial, buscarTiposUsuarios } = useTipoUsuario();
    const [filtroTipoUsuario, setFiltroTipoUsuario] = useState<TipoUsuario>(tipoUsuarioInitial);
    const [newTipoUsuario] = useState<TipoUsuario>(tipoUsuarioInitial);

    useEffect(() => {
        buscarTiposUsuarios(filtroTipoUsuario);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleChange = (e: any) => {
        e.preventDefault();
        setFiltroTipoUsuario({
            ...filtroTipoUsuario,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = (e: any) => {
        e.preventDefault();
        buscarTiposUsuarios(filtroTipoUsuario);
    }

    const handleClean = () => {
        setFiltroTipoUsuario(newTipoUsuario);
    };

    return (
        <div className="card">
            <form id="dto" className="form-horizontal" action="buscarPermisos" method="post">
                <div className="card-body">
                    <h4 className="m-t-0 header-title">
                        <i className="fa fa-search margin-right-7" aria-hidden="true" style={{ marginRight: "5px" }}></i>
                        Buscar
                    </h4>
                    <hr />
                    <div className="row">
                        <div className="col-md-4">
                            <label style={{ color: "grey" }}>
                                Nombre
                            </label>
                            <input id="nombre" name="nombre" className="form-control" type="text" value={filtroTipoUsuario.nombre} onChange={handleChange} />

                        </div>
                        <div className="col-md-4">
                            <label style={{ color: "grey" }}>
                                Acrónimo
                            </label>
                            <input id="valor" name="valor" className="form-control" type="text" value={filtroTipoUsuario.valor} onChange={handleChange} />

                        </div>

                    </div>
                    <hr />
                    <div className="row">
                        <div className="col-md-12 text-center">

                            <button className="btn btn-secondary btn-rounded waves-effect waves-light mr-1" type="button" id="limpiarFiltro" onClick={handleClean}>
                                <i className="fa fa-refresh mr-1" aria-hidden="true"></i>
                                Limpiar
                            </button>
                            <button className="btn btn-success btn-rounded waves-effect waves-light " type="submit" onClick={handleSubmit}>
                                <i className="fa fa-search mr-1"></i>
                                Buscar
                            </button>

                        </div>
                    </div>

                </div>
            </form>
        </div>
    )
}
